import script from "./CollectDataStudy.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectDataStudy.vue?vue&type=script&setup=true&lang=js"

import "./CollectDataStudy.vue?vue&type=style&index=0&id=8ae2361a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ae2361a"]])

export default __exports__